import React from 'react';

// Exact TradingView symbol mapping for major UK stocks (as per tradingview.com)
const tradingViewSymbolMap = {
  'HSBA.L': {
    widget: 'LSE:HSBA',
    web: 'LSE-HSBA',
    lse: 'https://www.londonstockexchange.com/stock/HSBA/hsbc-holdings-plc',
  },
  'BP.L': {
    widget: 'LSE:BP.',
    web: 'LSE-BP.',
    lse: 'https://www.londonstockexchange.com/stock/BP./bp-plc',
  },
  'GSK.L': {
    widget: 'LSE:GSK',
    web: 'LSE-GSK',
    lse: 'https://www.londonstockexchange.com/stock/GSK/gsk-plc',
  },
  'VOD.L': {
    widget: 'LSE:VOD',
    web: 'LSE-VOD',
    lse: 'https://www.londonstockexchange.com/stock/VOD/vodafone-group-plc',
  },
  'AZN.L': {
    widget: 'LSE:AZN',
    web: 'LSE-AZN',
    lse: 'https://www.londonstockexchange.com/stock/AZN/astrazeneca-plc',
  },
  'BARC.L': {
    widget: 'LSE:BARC',
    web: 'LSE-BARC',
    lse: 'https://www.londonstockexchange.com/stock/BARC/barclays-plc',
  },
  'LLOY.L': {
    widget: 'LSE:LLOY',
    web: 'LSE-LLOY',
    lse: 'https://www.londonstockexchange.com/stock/LLOY/lloyds-banking-group-plc',
  },
  'RIO.L': {
    widget: 'LSE:RIO',
    web: 'LSE-RIO',
    lse: 'https://www.londonstockexchange.com/stock/RIO/rio-tinto-plc',
  },
  'DGE.L': {
    widget: 'LSE:DGE',
    web: 'LSE-DGE',
    lse: 'https://www.londonstockexchange.com/stock/DGE/diageo-plc',
  },
  'ULVR.L': {
    widget: 'LSE:ULVR',
    web: 'LSE-ULVR',
    lse: 'https://www.londonstockexchange.com/stock/ULVR/unilever-plc',
  },
  'BATS.L': {
    widget: 'LSE:BATS',
    web: 'LSE-BATS',
    lse: 'https://www.londonstockexchange.com/stock/BATS/british-american-tobacco-plc',
  },
  'RDSA.L': {
    widget: 'LSE:RDSA',
    web: 'LSE-RDSA',
    lse: 'https://www.londonstockexchange.com/stock/RDSA/shell-plc',
  },
  'NG.L': {
    widget: 'LSE:NG.',
    web: 'LSE-NG.',
    lse: 'https://www.londonstockexchange.com/stock/NG./national-grid-plc',
  },
  'IMB.L': {
    widget: 'LSE:IMB',
    web: 'LSE-IMB',
    lse: 'https://www.londonstockexchange.com/stock/IMB/imperial-brands-plc',
  },
  'SMIN.L': {
    widget: 'LSE:SMIN',
    web: 'LSE-SMIN',
    lse: 'https://www.londonstockexchange.com/stock/SMIN/smiths-group-plc',
  },
  'SHEL.L': {
    widget: 'LSE:SHEL',
    web: 'LSE-SHEL',
    lse: 'https://www.londonstockexchange.com/stock/SHEL/shell-plc',
  },
  'PRU.L': {
    widget: 'LSE:PRU',
    web: 'LSE-PRU',
    lse: 'https://www.londonstockexchange.com/stock/PRU/prudential-plc',
  },
  'AAL.L': {
    widget: 'LSE:AAL',
    web: 'LSE-AAL',
    lse: 'https://www.londonstockexchange.com/stock/AAL/anglo-american-plc',
  },
  'BHP.L': {
    widget: 'LSE:BHP',
    web: 'LSE-BHP',
    lse: 'https://www.londonstockexchange.com/stock/BHP/bhp-group-plc',
  },
  'TSCO.L': {
    widget: 'LSE:TSCO',
    web: 'LSE-TSCO',
    lse: 'https://www.londonstockexchange.com/stock/TSCO/tesco-plc',
  },
  // Add more as needed, matching TradingView and LSE exactly
};

const ChartModal = ({ symbol, onClose }) => {
  if (!symbol) return null;

  // Normalize symbol for mapping lookup
  const normalizedSymbol = symbol ? (symbol.toUpperCase().endsWith('.L') ? symbol.toUpperCase() : symbol.toUpperCase() + '.L') : '';
  const mapping = tradingViewSymbolMap[normalizedSymbol] || null;
  let tvSymbol = mapping ? mapping.widget : null;
  let tvWebSymbol = mapping ? mapping.web : null;
  let lseUrl = mapping ? mapping.lse : null;
  let tradingViewUrl = tvWebSymbol ? `https://www.tradingview.com/symbols/${tvWebSymbol}/` : null;

  // Fallback: if not in map, but looks like an LSE symbol, construct TradingView symbol
  if (!tvSymbol && symbol.endsWith('.L')) {
    const base = symbol.replace('.L', '');
    tvSymbol = `LSE:${base}`;
    tradingViewUrl = `https://www.tradingview.com/symbols/LSE-${base}/`;
    // Always provide a generic LSE URL for .L stocks (no slug)
    lseUrl = `https://www.londonstockexchange.com/stock/${base}`;
  }
  // If still no lseUrl but symbol is all caps and <=5 chars, try generic LSE URL
  if (!lseUrl && symbol && symbol.length <= 5 && symbol.toUpperCase() === symbol) {
    lseUrl = `https://www.londonstockexchange.com/stock/${symbol}`;
  }

  // Always construct the base symbol for LSE URL
  const baseSymbol = symbol.endsWith('.L') ? symbol.replace('.L', '') : symbol;
  // Use mapped slug URL if available, otherwise fallback to generic
  const lseUrlUser = mapping && mapping.lse ? mapping.lse : (baseSymbol ? `https://www.londonstockexchange.com/stock/${baseSymbol}` : null);
  const isFallbackLseUrl = !(mapping && mapping.lse);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white dark:bg-gray-900 rounded-lg shadow-lg p-4 max-w-3xl w-full relative">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white"
        >
          ✕
        </button>
        <h2 className="text-xl font-bold mb-4 text-center">{symbol} Chart</h2>
        {/* Debug: show actual symbol used */}
        <div className="text-xs text-gray-400 text-center mb-2">[DEBUG] Symbol: {symbol}</div>
        <div className="w-full h-[400px]">
          {tvSymbol ? (
            <iframe
              title={`${symbol} Chart`}
              src={`https://s.tradingview.com/widgetembed/?symbol=${tvSymbol}&interval=D&hidesidetoolbar=1&symboledit=1&saveimage=1&toolbarbg=f1f3f6&studies=[]&theme=light&style=1&timezone=Etc/UTC&withdateranges=1&hideideas=1&hidevolume=0&hidelegend=0&studies_overrides={}`}
              width="100%"
              height="400"
              frameBorder="0"
              allowFullScreen
            />
          ) : (
            <div className="flex flex-col items-center justify-center h-full text-center text-red-600 dark:text-red-400">
              <p className="text-lg font-semibold mb-2">This symbol is not available on TradingView.</p>
              <p className="text-sm mb-4">Please select a major UK stock or check the symbol format.</p>
              {tradingViewUrl && (
                <a
                  href={tradingViewUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block px-4 py-2 bg-primary-600 text-white rounded hover:bg-primary-700 transition mb-2"
                >
                  View on TradingView
                </a>
              )}
            </div>
          )}
        </div>
        {/* Always show LSE Chart button at the bottom for any stock */}
        {lseUrlUser && (
          <div className="flex flex-col items-center mt-4">
            <a
              href={lseUrlUser}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-4 py-2 bg-blue-700 text-white rounded hover:bg-blue-800 transition"
              title={isFallbackLseUrl ? 'This link may not work for all stocks. If you see a 404, try searching manually on the LSE site.' : 'View the official LSE chart for this stock.'}
            >
              View LSE Chart
            </a>
            {isFallbackLseUrl && (
              <span className="text-xs text-gray-500 mt-1">If the LSE page does not load, try searching for the company on the LSE website.</span>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ChartModal; 